// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9dc0d4bc","239":"7dce94d2","453":"32a698a2","553":"8cf8ddbb"}[chunkId] + ".chunk.js";
};